import { useState, useRef } from "react";
import { initVehiculoExpresFree, ITEMS_VEHICULO_EXPRES_FREE } from '../constants/freeFormConfig';
import { Inp, ChecklistSeccion, FirmaCanvas, CampoPDF, ChecklistSeccionPDF, FirmaPDF, ModalCuotaFree } from './ui/FormControls';
import { generarPdfFree, nombreArchivoPdfFree } from '../services/pdf-free';
import { useDescargaFree } from '../hooks/useDescargaFree';

// ── PLAN FREE: Vehículo Exprés (checklist rápido diario) ──────────
export const FreeVehiculoExpresForm = () => {
  const [form, setForm] = useState(initVehiculoExpresFree());
  const [completado, setCompletado] = useState(false);
  const [pdfDoc, setPdfDoc] = useState(null);
  const printRef = useRef(null);
  const { intentarDescarga, generando, bloqueo, cerrarBloqueo } = useDescargaFree();
  const listo = form.nombre.trim() && form.matricula.trim() && form.firma;
  const validadoPorTexto = `Validado por: ${form.nombre || "—"} · ${new Date().toLocaleDateString("es-ES")} ${new Date().toLocaleTimeString("es-ES", { hour: "2-digit", minute: "2-digit" })}`;

  const finalizar = () => intentarDescarga(async () => {
    const doc = await generarPdfFree(printRef.current);
    setPdfDoc(doc);
    setCompletado(true);
  });

  const descargar = () => pdfDoc?.save(nombreArchivoPdfFree("vehiculo_expres", form.matricula));

  return (
    <>
      {completado ? (
        <div className="bg-white rounded-xl shadow p-4 space-y-4 text-center">
          <p className="text-2xl">✅</p>
          <h2 className="font-bold text-gray-800">Checklist completado</h2>
          <p className="text-sm text-gray-500">{validadoPorTexto}</p>
          <button onClick={descargar} className="w-full bg-blue-600 text-white font-bold py-3 rounded-xl hover:bg-blue-700 transition-all">Descargar PDF</button>
          <button onClick={() => setCompletado(false)} className="text-xs text-gray-400 hover:text-gray-600">← Volver al checklist</button>
        </div>
      ) : (
        <div className="bg-white rounded-xl shadow p-4 space-y-4">
          <h2 className="font-bold text-gray-800 border-b pb-2">🚐 Vehículo Exprés</h2>
          <div className="grid grid-cols-2 gap-3">
            <Inp label="Nombre *" value={form.nombre} onChange={v => setForm(f => ({ ...f, nombre: v }))} placeholder="Nombre completo" />
            <Inp label="Matrícula *" value={form.matricula} onChange={v => setForm(f => ({ ...f, matricula: v }))} placeholder="0000-AAA" />
          </div>
          <Inp label="Fecha" type="date" value={form.fecha} onChange={v => setForm(f => ({ ...f, fecha: v }))} />

          <ChecklistSeccion titulo="Comprobación rápida" color="bg-blue-50 text-blue-700" items={ITEMS_VEHICULO_EXPRES_FREE} value={form.items} onChange={items => setForm(f => ({ ...f, items }))} />

          <div>
            <label className="text-xs font-semibold text-gray-600 uppercase">Observaciones</label>
            <textarea className="w-full border rounded-lg px-3 py-2 text-sm mt-1 focus:outline-none focus:ring-2 focus:ring-blue-400" rows={3} value={form.observaciones} onChange={e => setForm(f => ({ ...f, observaciones: e.target.value }))} />
          </div>

          <FirmaCanvas onChange={firma => setForm(f => ({ ...f, firma }))} />
          {form.firma && <p className="text-xs text-gray-500 text-center">{validadoPorTexto}</p>}

          <button onClick={finalizar} disabled={!listo || generando} className="w-full bg-blue-600 text-white font-bold py-3 rounded-xl hover:bg-blue-700 disabled:opacity-40 transition-all">
            {generando ? "Generando PDF..." : "Finalizar checklist →"}
          </button>
        </div>
      )}

      {/* Vista oculta de solo lectura, usada únicamente para generar el PDF */}
      <div ref={printRef} style={{ position: "absolute", left: "-9999px", top: 0, width: 800 }} className="bg-white p-6 space-y-4">
        <h2 className="font-bold text-gray-800 border-b pb-2">🚐 Vehículo Exprés</h2>
        <div className="grid grid-cols-2 gap-3">
          <CampoPDF label="Nombre" value={form.nombre} />
          <CampoPDF label="Matrícula" value={form.matricula} />
        </div>
        <CampoPDF label="Fecha" value={form.fecha} />
        <ChecklistSeccionPDF titulo="Comprobación rápida" color="bg-blue-50 text-blue-700" items={ITEMS_VEHICULO_EXPRES_FREE} value={form.items} />
        <CampoPDF label="Observaciones" value={form.observaciones} />
        <FirmaPDF dataUrl={form.firma} />
        <p className="text-xs text-gray-500 text-center">{validadoPorTexto}</p>
      </div>

      <ModalCuotaFree bloqueo={bloqueo} onClose={cerrarBloqueo} />
    </>
  );
};
